module.exports = __webpack_public_path__ + "fonts/fs_lola-bold-webfont.f5d99a92.woff";